import { frontendURL } from '../../../helper/URLHelper';
import { ROLES } from 'dashboard/constants/permissions.js';
import AtendimentoIndex from './pages/AtendimentoIndex.vue';
import ComercialIndex from './pages/ComercialIndex.vue';
import MeuEspacoIndex from './pages/MeuEspacoIndex.vue';
import AgentReportsShow from '../settings/reports/AgentReportsShow.vue';
import LabelReportsShow from '../settings/reports/LabelReportsShow.vue';
import InboxReportsShow from '../settings/reports/InboxReportsShow.vue';
import TeamReportsShow from '../settings/reports/TeamReportsShow.vue';
import ReportsWrapper from '../settings/reports/components/ReportsWrapper.vue';

const commonMeta = {
  permissions: ['administrator', 'report_manage'],
};

// "Meu espaço" é sobre o próprio usuário, então qualquer agente ou
// administrador acessa — não exige permissão de Relatórios (spec 143).
const meuEspacoMeta = {
  permissions: ROLES,
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/painel'),
    redirect: to => ({
      name: 'painel_meu_espaco',
      params: to.params,
    }),
  },
  {
    path: frontendURL('accounts/:accountId/painel/atendimento'),
    name: 'painel_atendimento',
    component: AtendimentoIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/painel/comercial'),
    name: 'painel_comercial',
    component: ComercialIndex,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/painel/meu-espaco'),
    name: 'painel_meu_espaco',
    component: MeuEspacoIndex,
    meta: meuEspacoMeta,
  },
  // Telas de detalhe reaproveitadas de Relatórios (spec 143 v3): mesmos
  // componentes, só uma rota nova em /painel (dependem só de route.params.id).
  // Precisa do mesmo ReportsWrapper de Relatórios como ancestral — é ele quem
  // dá a largura/padding que esses componentes esperam.
  {
    path: frontendURL('accounts/:accountId/painel/atendimento'),
    component: ReportsWrapper,
    children: [
      {
        path: 'usuarios/:id',
        name: 'painel_agent_reports_show',
        component: AgentReportsShow,
        meta: commonMeta,
      },
      {
        path: 'etiquetas/:id',
        name: 'painel_label_reports_show',
        component: LabelReportsShow,
        meta: commonMeta,
      },
      {
        path: 'canais/:id',
        name: 'painel_inbox_reports_show',
        component: InboxReportsShow,
        meta: commonMeta,
      },
      {
        path: 'time/:id',
        name: 'painel_team_reports_show',
        component: TeamReportsShow,
        meta: commonMeta,
      },
    ],
  },
];
